import { Component, DestroyRef, EventEmitter, inject, Input, Output } from '@angular/core';

import { Observable } from 'rxjs';

import { Constants } from '../../../helpers';
import { ChargeModel } from '../../../models';
import { AdditionalChargeService } from '../../../services/additional-charge.service';
import { BoqService } from '../../../services/boq.service';
import { AddContactTextConst } from '../contact-dialog/components/add-contact-person/common/add-contact-person.constants';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Component({
	selector: 'app-comments-edit-dialog',
	templateUrl: './comments-edit-dialog.component.html',
})
export class CommentsEditDialogComponent {
	@Input()
	public set charge(charge: ChargeModel) {
		this._charge = charge;

		if (!this._charge) {
			return;
		}

		this.isBoq = this._charge.chargeType === Constants.CHARGE_TYPES.Boq;

		if (this.isBoq) {
			this.boqComment = this._charge.chargeOutAmounts.comment;
			this.boqInternalComment = this._charge.chargeOutAmounts.internalComment;
		} else if (!this.isBoq) {
			this.additionalChargeComment = this._charge.comment;
			this.additionalChargeInternalComment = this._charge.internalComment;
		}
	}

	@Input() public isDisabled: boolean = false;
	@Input() public projectId: string;

	@Output() public chargeUpdated: EventEmitter<void> = new EventEmitter<void>();

	public additionalChargeComment: string;
	public additionalChargeInternalComment: string;
	public boqComment: string;
	public boqInternalComment: string;
	public _charge: any;
	public isBoq: boolean;
	public text: typeof AddContactTextConst = AddContactTextConst;
	private destroyRef = inject(DestroyRef);

	constructor(
		private additionalChargeService: AdditionalChargeService,
		private boqService: BoqService,
	) {}

	public onSave(): void {
		if (this.isBoq) {
			this._charge.chargeOutAmounts.comment = this.boqComment;
			this._charge.chargeOutAmounts.internalComment = this.boqInternalComment;
		} else {
			this._charge.comment = this.additionalChargeComment;
			this._charge.internalComment = this.additionalChargeInternalComment;
		}

		const saveChargeObservable: Observable<any> = this.isBoq
			? this.boqService.editBoq(this._charge, this._charge.project)
			: this.additionalChargeService.editAdditionalCharge(this._charge._id, this._charge, this.projectId);

		saveChargeObservable.pipe(takeUntilDestroyed(this.destroyRef)).subscribe(() => this.chargeUpdated.emit());
	}
}
